import React from 'react';
import PropTypes from 'prop-types';

import  { lazy } from 'react';
import { Link as ReactLink } from 'react-router-dom';

const NextLinkComponent = lazy(() => import('next/link'));

const Link = ({
   children,
   isNextApp,
   href,
   className = '',
   prefetch,
}) => {
   if(!href){
      return (
         <>
            {children}
         </>
      )
   }
   if(isNextApp){
      return (
         <NextLinkComponent href={ href } className={ className } prefetch={ prefetch }>
            {children}
         </NextLinkComponent>
      )
   }
   return (
      <ReactLink to={ href } className={ className }>
         {children}
      </ReactLink>
   )
}



Link.propTypes = {
   children: PropTypes.any,
   isNextApp: PropTypes.string,
   className: PropTypes.string,
   prefetch: PropTypes.bool,
   href: PropTypes.string,
};

export default Link;
